import { IonRow, IonCol } from '@ionic/react'
import React from 'react'
import ItemAbout, { Item } from './ItemAbout'

interface Props {
  title: string,
  items: Item[],
}

const ListItemAbout: React.FC<Props> = props => {

  return (
    <IonRow>
      <IonCol>
        <IonRow>
          <h4>{props.title}</h4>
        </IonRow>
        <IonRow className="ion-justify-content-center ion-margin-bottom">
          {
            props.items.map(item => (
              <ItemAbout key={item.id} {...item} />
            ))
          }
        </IonRow>
      </IonCol>
    </IonRow>
  )
}

export default ListItemAbout
